export const ROLES = {
  SUPER_ADMIN: "superadmin",
  ADMIN: "admin",
  VENDOR: "vendor",
  PARENT: "parent",
  ALL: "all",
  STORES:"stores",
  ACCOUNTS:"accounts"
};

export const API_BASE_URL = "https://s3j7mxmpfv.ap-south-1.awsapprunner.com";
// export const API_BASE_URL = "http://localhost:3002";
  // "https://nestschoolbackend-production.up.railway.app";

export const PAYMENT_MODE = {
  credit_card: "Credit/Debit Card",
  upi: "UPI",
  net_banking: "Net Banking",
  na: "Not Applicable",
};

export const studentTypeList = [
  { label: "New", key: "New" },
  { label: "Existing", key: "Existing" },
  // { label: "Hostel", key: "Hostel" },
  { label: "Hostel_New", key: "Hostel_New" },
  { label: "Hostel_Existing", key: "Hostel_Existing" }
];

export const genderList = [
  { label: "Male", key: "Male" },
  { label: "Female", key: "Female" },
];

export const boardingStatusList = [
  { key: "Yes", label: "Yes" },
  { key: "No", label: "No" },
];

export const houseList = [
  { key: "Dragons", label: "Dragons" },
  { key: "Griffins", label: "Griffins" },
  { key: "Sphinx", label: "Sphinx" },
  { key: "Pegasus", label: "Pegasus" },
];

export const classList = [
  { key: "Nursery", label: "Nursery" },
  { key: "PP1", label: "PP1" },
  { key: "PP2", label: "PP2" },
  { key: "I", label: "I" },
  { key: "II", label: "II" },
  { key: "III", label: "III" },
  { key: "IV", label: "IV" },
  { key: "V", label: "V" },
  { key: "VI", label: "VI" },
  { key: "VII", label: "VII" },
  { key: "VIII", label: "VIII" },
  { key: "IX", label: "IX" },
  { key: "X", label: "X" },
  { key: "XI", label: "XI" },
  { key: "XII", label: "XII" },
];

export const sectionList = [
  { label: "A", key: "A" },
  { label: "A26-27", key: "A26-27" },
  { label: "A (25-26)", key: "A (25-26)" },
  { label: "B", key: "B" },
  { label: "B (25-26)", key: "B (25-26)" },
  { label: "C", key: "C" },
  { label: "D", key: "D" },
  { label: "E", key: "E" },
  { label: "F", key: "F" },
  { label: "G", key: "G" },
  { label: "GA", key: "GA" },
  { label: "GB", key: "GB" },
  { label: "GC", key: "GC" },
  { label: "GD", key: "GD" },
  { label: "GE", key: "GE" },
  { label: "H", key: "H" },
  { label: "I", key: "I" },
  { label: "K", key: "K" },
  { label: "L", key: "L" },
  { label: "M", key: "M" },
  { label: "NA", key: "NA" },
  { label: "NB", key: "NB" },
  { label: "NC", key: "NC" },
  { label: "ND", key: "ND" },
  { label: "NE", key: "NE" },
  { label: "NF", key: "NF" },
  { label: "NP", key: "NP" },
  { label: "SA", key: "SA" },
  { label: "SB", key: "SB" },
  { label: "SC", key: "SC" },
  { label: "SD", key: "SD" },
  { label: "SE", key: "SE" },
  { label: "SF", key: "SF" },
  { label: "TA", key: "TA" },
  { label: "TB", key: "TB" },
  { label: "TC", key: "TC" },
  { label: "TD", key: "TD" },
  { label: "TE", key: "TE" }
];

export const campusList = [
  { label: "Kollur", key: "Kollur" },
  { label: "Nanakram Guda", key: "Nanakram Guda" },
];

export const statusList = [
  { label: "Active", key: true },
  { label: "In-Active", key: false },
];

export const SUPORT_ATTACHMENT_URL =
  "https://api.cloudinary.com/v1_1/dwgfx9feh/image/upload";
